import { render, staticRenderFns } from "./Pagination2.vue?vue&type=template&id=c98ee854&scoped=true&"
import script from "./Pagination2.vue?vue&type=script&lang=js&"
export * from "./Pagination2.vue?vue&type=script&lang=js&"
import style0 from "./Pagination2.vue?vue&type=style&index=0&id=c98ee854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98ee854",
  null
  
)

export default component.exports